import { useRef } from "react";
import "./KursetGallery.css";

const photos = [
  { src: require("../assets/ChatGPT Image May 19, 2025, 09_51_36 AM.png"), alt: "Ambient Fox 1" },
  { src: require("../assets/ChatGPT Image May 19, 2025, 09_59_01 AM.png"), alt: "Ambient Fox 2" },
  { src: require("../assets/ChatGPT Image May 19, 2025, 09_49_52 AM.png"), alt: "Ambient Fox 3" },
];

export function KursetGallery() {
  const wrapperRef = useRef();

  function handleMouseMove(e) {
    const { left, width } = wrapperRef.current.getBoundingClientRect();
    const x = e.clientX - left;
    const percent = x / width;
    const maxShift = width * (photos.length - 1);
    wrapperRef.current.querySelector(
      ".gallery-panorama-inner"
    ).style.transform = `translateX(-${percent * maxShift}px)`;
  }

  function handleMouseLeave() {
    wrapperRef.current.querySelector(
      ".gallery-panorama-inner"
    ).style.transform = `translateX(0)`;
  }

  return (
    <div
      className="gallery-panorama"
      ref={wrapperRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="gallery-panorama-inner">
        {photos.map((foto, i) => (
          <img
            src={foto.src}
            alt={foto.alt}
            className="gallery-panorama-img"
            key={i}
            draggable={false}
          />
        ))}
      </div>
    </div>
  );
}
